import { OktaAuth } from '@okta/okta-auth-js';
import { getEnv } from '../utils/helpers';

/**
 * Security component configuration for Okta.
 *
 * @type {OktaAuth}
 */
const oktaAuth = new OktaAuth({
    clientId: getEnv('REACT_APP_OKTA_CLIENT_ID'),
    issuer: getEnv('REACT_APP_OKTA_ISSUER'),
    redirectUri: `${window.location.origin}/implicit/callback`,
    scopes: getEnv('REACT_APP_OKTA_SCOPES').split(' '),
    pkce: true,
    tokenManager: {
        storage: 'sessionStorage',
    },
});

export default oktaAuth;
